import {
  AUTH_LOADING,
  LOG_OUT,
  SIGN_IN,
  SIGN_IN_FAILED,
  TRY_AGAIN,
  RESET_AUTH
} from "../types";
import jwt_decode from "jwt-decode";
import api from "../../api";
import { authEndpoint, LogoutEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";

export const signIn = (username: any, password: any, partnerId: string) => {
  return async (
    dispatch: (arg0: { type: string; loading?: boolean; payload?: any; role?: any; toUpdatePassword?: boolean, exp?: number,accountName?: string, id?: any; error?: any; userId?: any, partnerId?: string, pgId?: string, refreshToken?: string }) => void
  ) => {
    //let role: any;
    //let toUpdatePassword: any;
    //let userId: any;

    dispatch({ type: AUTH_LOADING, loading: true });
    await api.post(authEndpoint(), JSON.stringify({ username, password }), {
      headers: {
        "Content-type": "application/json",
        //partnerId
      },
    })
      .then((res: any) => {

        //const decoded: any = jwt_decode(res.data.LoginToken.accessToken);
        //const id = decoded.merchant_id;
        // const id = "";
        // const userId = res.data.userId;
        // const partnerId = res.data.partner?.partnerId;
        // const pgId = res.data.partner?.partnerPgId;
        // const refreshToken = res.data.LoginToken.refreshToken
        //role = decoded.resource_access["api-gateway"].roles[0];
        //role = "user";
        dispatch({ type: AUTH_LOADING, loading: false, payload: { username, password } });
        //dispatch({ type: AUTH_LOADING, loading: false });
        //dispatch({ type: SIGN_IN, payload: res.data.LoginToken, role, toUpdatePassword, id, userId, partnerId, pgId, refreshToken });
        dispatch({ type: SIGN_IN, partnerId });
      })
      .catch((err) => {
        apiError(AUTH_LOADING, SIGN_IN_FAILED, err, dispatch);
      });
  };
};



export const logout = (token: string, refreshToken: string) => {
  return async (dispatch: (arg0: { type: string; loading?: boolean; payload?: any }) => any) => {


    dispatch({ type: AUTH_LOADING, loading: true });
    await api.post(LogoutEndpoint(), {}, {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Refresh-Token": refreshToken
      },
    })
      .then((res) => {

        dispatch({ type: AUTH_LOADING, loading: false });
        dispatch({ type: LOG_OUT, payload: res.data.message })
        //dispatch({ type: SIGN_IN, payload: res.data.LoginToken, role, toUpdatePassword, id, userId, partnerId, pgId, refreshToken });
      })
      .catch((err) => {
        apiError(AUTH_LOADING, SIGN_IN_FAILED, err, dispatch);
      });

  };
};



/* export const logout = () => {
  return (dispatch: (arg0: { type: string }) => any) => {



    return dispatch({ type: LOG_OUT });
  };
}; */


export const tryAgain = () => {
  return (dispatch: (arg0: { type: string }) => any) => {
    return dispatch({ type: TRY_AGAIN });
  };
};




export const resetAuth = () => {
  return {
    type: RESET_AUTH
  }
}